/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import * as actionTypes from '../constants/action-types';
import { AnyAction } from 'redux';

const defaultState = { isOpen: false, permissionRequired: [] };

const upgradeModal = (
  state = defaultState,
  action: AnyAction,
) => {
  switch (action.type) {

    case actionTypes.SHOW_UPGRADE_MODAL:
      return { isOpen: true, permissionRequired: action.permissionRequired }
    case actionTypes.HIDE_UPGRADE_MODAL:
      return defaultState;
    default:
      return state;

  }

}

export default upgradeModal;
